import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, inject, signal } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { TranslationService } from '../../shared/i18n/translation.service';

@Component({
  selector: 'app-evenement-detail',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './evenement-detail.html',
  styleUrls: ['./evenement-detail.scss']
})
export class EvenementDetailComponent implements OnInit, OnDestroy {
  private readonly http = inject(HttpClient);
  private readonly route = inject(ActivatedRoute);
  private readonly sanitizer = inject(DomSanitizer);
  readonly i18n = inject(TranslationService);

  readonly event = signal<any | null>(null);
  readonly loading = signal(true);
  readonly notFound = signal(false);
  readonly iframeLoaded = signal(false);
  readonly embedUrl = signal<SafeResourceUrl | null>(null);
  private subscription?: Subscription;

  ngOnInit(): void {
    const slug = this.route.snapshot.paramMap.get('slug') ?? '';
    this.subscription = this.http.get<any[]>(`${environment.apiUrl}/events`).subscribe({
      next: rows => {
        const event = rows.find(row => String(row.slug ?? row.id) === slug && (row.event_type ?? 'event') === 'event')
          ?? (slug === 'tombola-solidaire-maranatha-2026'
            ? rows.find(row => String(row.title_fr ?? row.title ?? '').toLowerCase().includes('tombola solidaire maranatha'))
            : null)
          ?? null;
        this.event.set(event);
        this.notFound.set(!event);
        this.embedUrl.set(event ? this.toHelloAssoWidget(event.registration_url ?? event.helloAssoUrl) : null);
        this.loading.set(false);
      },
      error: () => {
        this.notFound.set(true);
        this.loading.set(false);
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  localized(field: string): string {
    const item = this.event();
    if (!item) return '';
    return item[`${field}_${this.i18n.language()}`] ?? item[field] ?? item[`${field}_fr`] ?? '';
  }
  mediaUrl(value: unknown): string {
    const url = String(value ?? '').trim();
    if (/^www\./i.test(url)) return `https://${url}`;
    if (/^http:\/\//i.test(url)) return url.replace(/^http:\/\//i, 'https://');
    if (url.startsWith('/uploads/')) return `${environment.apiUrl.replace(/\/$/, '')}${url}`;
    return url;
  }
  hideBrokenImage(event: Event): void { (event.target as HTMLImageElement).style.display = 'none'; }

  isTombola(): boolean {
    const item = this.event();
    return String(item?.slug ?? item?.title_fr ?? '').toLowerCase().includes('tombola');
  }

  eventDate(): string {
    const value = this.event()?.starts_at;
    if (!value) return '';
    return new Intl.DateTimeFormat(this.i18n.language() === 'en' ? 'en-GB' : 'fr-FR', {
      dateStyle: 'full',
      timeStyle: 'short'
    }).format(new Date(value));
  }

  private toHelloAssoWidget(url?: string): SafeResourceUrl | null {
    if (!url || !/^https:\/\/(www\.)?helloasso\.com\//i.test(url)) return null;
    const clean = url.replace(/\/$/, '');
    const widget = clean.endsWith('/widget') ? clean : `${clean}/widget`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(widget);
  }
}
